<template>
  <tr :data-testid="`event-app-row-${attendee.id}`">
    <td v-if="props.displayCheckbox" class="border-b border-main pr-2">
      <div class="flex items-center pl-2">
        <CheckBox :model-value="checked" class="text-main" data-testid="event-app-row-checkbox" @update:model-value="adjustSelection" />
      </div>
    </td>
    <td class="border-b border-main py-3 pr-2" :class="blur">
      {{ attendee.ticket?.companyName }}
    </td>
    <td v-if="props.displayTicketNumber" class="border-b border-main py-3 pr-2" :class="blur">
      {{ attendee.addedViaManage ? attendee.ticket?.identifier : '' }}
    </td>
    <td class="border-b border-main py-3 pr-2" :class="blur">
      {{ attendee.ticket?.position ? attendee.ticket.position : 'Student' }}
    </td>
    <td v-if="props.displayState" class="border-b border-main py-3 pl-2">
      <div :class="statusColor" data-testid="event-app-row-status">
        {{ statusLabel }}
      </div>
    </td>
  </tr>
</template>

<script lang="ts">
export default { name: 'EventApplicationTableRow' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { Attendee } from '@/gql/myomr'

import { getStatusColor, getStatusLabel } from './statusHelper.tailwind'

const { t } = useI18n()

const props = defineProps<{
  attendee: Attendee
  displayCheckbox: boolean
  displayState: boolean
  displayTicketNumber: boolean
  selectedAttendeeIds: string[]
}>()

const emit = defineEmits<{
  (e: 'select', value: string): void
  (e: 'unselect', value: string): void
}>()

const checked = computed(() => props.selectedAttendeeIds.includes(props.attendee.id))

function adjustSelection(newValue: boolean) {
  if (newValue) {
    emit('select', props.attendee.id)
  } else {
    emit('unselect', props.attendee.id)
  }
}

const statusLabel = computed(() => {
  return t(getStatusLabel(props.attendee.aasmState, props.attendee.forcedAllocation))
})

const statusColor = computed(() => {
  return getStatusColor(props.attendee.aasmState, props.attendee.forcedAllocation)
})

const blur = computed(() => (props.attendee.visibleToPartnerCompany ? '' : 'blur-sm'))
</script>
